var map = {
	"./balai-pustaka.png": "4c23",
	"./belajarid.png": "fb01",
	"./ikapi.png": "3e5e",
	"./kurikulum-merdeka.png": "6205",
	"./merdeka-belajar.png": "12f5",
	"./merdeka-mengajar.png": "01f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6972";